import { drawerClasses } from '@mui/material/Drawer';
import { listItemButtonClasses } from '@mui/material/ListItemButton';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { listItemTextClasses } from '@mui/material/ListItemText';
import { alpha, Theme } from '@mui/material/styles';

import { deepNavy, lilacScale } from '../../palette-v2';

// ----------------------------------------------------------------------
// V2 Design System — Drawer & Navigation menu overrides
// Matches Figma "Menu Drawer" component
// ----------------------------------------------------------------------

export function drawerV2(theme: Theme) {
  return {
    // ─── MUI DRAWER (mobile nav + custom drawers) ───────────────────────
    MuiDrawer: {
      styleOverrides: {
        root: {
          [`& .${drawerClasses.paper}`]: {
            backgroundColor: theme.palette.common.white,
            backgroundImage: 'none',
          },
        },
        paper: {
          backgroundColor: theme.palette.common.white,
          backgroundImage: 'none',
          borderRight: `1px solid ${alpha(deepNavy[200], 0.6)}`,
          boxShadow: `4px 0 24px -4px ${alpha(deepNavy[400], 0.08)}`,
        },
      },
    },

    // ─── LIST ITEM BUTTON (nav items) ───────────────────────────────────
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: '10px 12px',
          marginBottom: 4,
          color: deepNavy[700],
          transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.shorter,
          }),
          [`& .${listItemIconClasses.root}`]: {
            color: deepNavy[500],
            minWidth: 40,
          },
          [`& .${listItemTextClasses.primary}`]: {
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 500,
            color: deepNavy[700],
          },
          '&:hover': {
            backgroundColor: alpha(lilacScale[100], 0.5),
          },
          // ─── SELECTED / ACTIVE STATE ──────────────────────────────
          [`&.${listItemButtonClasses.selected}`]: {
            backgroundColor: alpha(lilacScale[500], 0.12),
            color: lilacScale[700],
            [`& .${listItemIconClasses.root}`]: {
              color: lilacScale[600],
            },
            [`& .${listItemTextClasses.primary}`]: {
              color: lilacScale[700],
              fontWeight: 600,
            },
            '&:hover': {
              backgroundColor: alpha(lilacScale[500], 0.18),
            },
          },
        },
      },
    },

    // ─── LIST ITEM ICON ─────────────────────────────────────────────────
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: deepNavy[500],
          minWidth: 40,
        },
      },
    },

    // ─── DIVIDER (section separators in nav) ────────────────────────────
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: alpha(deepNavy[200], 0.6),
        },
      },
    },
  };
}
